import React, { useState, useEffect } from 'react';
import { useAuth } from '../hooks/useAuth';
import api from '../services/api';
import toast from 'react-hot-toast';
import AccountSidebar from '../components/AccountSidebar';
import AccountContent from '../components/AccountContent';
import { useTranslation } from 'react-i18next';

export default function AccountSummary() {
    const { user } = useAuth();
    const { t } = useTranslation();
    const [userInfo, setUserInfo] = useState(null);
    const [loading, setLoading] = useState(true);
    const [isDocsVerified, setIsDocsVerified] = useState(false);
    const [is2faEnabled, setIs2faEnabled] = useState(false);

    useEffect(() => {
        fetchUserInfo();
    }, []);

    useEffect(() => {
        const fetchDocs = async () => {
            try {
                const res = await api.getExistingDocuments();
                const docs = res?.data || [];
                setIsDocsVerified(Array.isArray(docs) && docs.length === 3);
            } catch (e) {
                setIsDocsVerified(false);
            }
        };
        const fetch2fa = async () => {
            try {
                if (api.get2FactorStatus) {
                    const res = await api.get2FactorStatus();
                    // assume API returns { enabled: boolean } or similar structure
                    const enabled = (res?.data);
                    setIs2faEnabled(enabled);
                }
            } catch (e) {
                setIs2faEnabled(false);
            }
        };
        fetchDocs();
        fetch2fa();
    }, []);

    const fetchUserInfo = async () => {
        try {
            setLoading(true);
            const response = await api.getUserInfo();
            const userData = response.data?.data || response.data;
            // Map camelCase to PascalCase for consistency
            const normalizedData = {
                ...userData,
                Balance: userData.Balance ?? userData.balance,
                Credit: userData.Credit ?? userData.credit,
                FullName: userData.FullName ?? userData.fullName
            };
            setUserInfo(normalizedData);
        } catch (error) {
            console.error('Error fetching user info:', error);
            toast.error(t('accountSummary.errorFetchingInfo'));
        } finally {
            setLoading(false);
        }
    };

    if (loading) {
        return (
            <div className="account-layout acc-layout-mobile">
                <div className="loading-container">
                    <div className="loading-spinner"></div>
                    <p>{t('accountSummary.loading')}</p>
                </div>
            </div>
        );
    }

    return (
        <div className="account-layout acc-layout-mobile">
            <div className="container">
                <div className="account-wrapper">
                    <AccountSidebar activeItem="hesap-ozeti" />
                    <AccountContent userInfo={userInfo} isDocsVerified={isDocsVerified} is2faEnabled={is2faEnabled} />
                </div>
            </div>
        </div>
    );
}
